import { SvgIcon, SvgIconProps } from '@mui/material';

export function WarningErrorIcon({ sx = {}, ...props }: SvgIconProps) {
  return (
    <SvgIcon
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      sx={{ ...sx, fill: 'none' }}
    >
      <circle cx="12.5" cy="17" r="1" fill="white" />
      <path
        d="M12.4999 8.99997V14M4.82789 21H20.1721C21.9445 21 23.0649 19.1433 22.2041 17.6324L14.532 4.16592C13.6464 2.61136 11.3536 2.61136 10.468 4.16592L2.79587 17.6324C1.9351 19.1433 3.05546 21 4.82789 21Z"
        stroke="white"
        stroke-width="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default WarningErrorIcon;
